import { useMutation, useQuery, useQueryClient, type UseQueryResult } from '@tanstack/react-query';
import { useApiClient } from '../api/api-context.js';
import {
  listSessions,
  revokeSession,
  signOutEverywhere as signOutEverywhereRequest,
} from './auth-api.js';
import type { SessionSummary } from './auth-contract.js';

/** The devices this person is signed in on. */
export const sessionKeys = {
  all: ['auth', 'sessions'] as const,
};

export function useSessions(): UseQueryResult<SessionSummary[]> {
  const client = useApiClient();
  return useQuery({ queryKey: sessionKeys.all, queryFn: () => listSessions(client) });
}

export function useRevokeSession() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<void, unknown, string>({
    mutationFn: (sessionId) => revokeSession(client, sessionId),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: sessionKeys.all });
    },
  });
}

export function useSignOutEverywhere() {
  const client = useApiClient();
  return useMutation<void, unknown, void>({
    mutationFn: () => signOutEverywhereRequest(client),
  });
}
